<template>
  <v-container>
    <v-layout
      wrap
    >
      <v-flex xs12>
    <p class="error">{{ alert }}</p>
    <div class="camera-wrapper">
      <qrcode-stream id="scanPreview" @decode="onDecode" @init="onInit" />
    </div>
    Result: <br>

    <br>
    Error:<br>
    {{alert}}
      </v-flex>

    </v-layout>
  </v-container>
</template>

<style lang="scss">
.camera-wrapper {
  max-width: 100%;
  max-height: 100%;
  border: 5px solid white;
  overflow: auto;
}
</style>

<script>

import { QrcodeStream } from 'vue-qrcode-reader'
import TicketMixin from '@/mixins/TicketMixin';
export default {
  mixins: [TicketMixin],
  components: { QrcodeStream },
  methods: {
    onDecode (result) {
      var uid = this.validateAndRetrunTicketUid(result)
      if(uid){
        this.checkIn(uid)
      }else{
        this.flashError('QR Read but ticket not recognized')
      }
    },
    validateAndRetrunTicketUid(data) {
        // Decode
        try {
          var decoded  = atob(data)
        }
        catch(error) {
          return false
        }
        
        // String to Json
        try {
          var json = JSON.parse(decoded);
        }
        catch(error) {
          return false
        }

        // Try to find uid in Json
        try {
          return json['ticket-uid']
        }
        catch(error) {
          return false
        }

    },
    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    }
  }
}

</script>
